import React from 'react';
import { GlobeIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy py-16 pb-28 sm:pb-16" data-id="element-50" data-mp="3gfsmebmgesmg">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-51" data-mp="3ghc5e9zhvhrx">
        <p className="font-serif text-3xl font-light text-white sm:text-4xl" data-id="element-52" data-mp="32ovuyo49khgz">
          Cenia Badillo <span className="text-gold" data-id="element-53" data-mp="36oo5h6d7wxoz">|</span> CB Realty
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-10" data-id="element-54" data-mp="3uf0lz5mj42r6">
          <a href="tel:+16513872889" className="inline-flex items-center gap-2 font-sans text-sm font-light text-white transition-colors hover:text-gold" data-id="element-55" data-mp="38h4x8q3ngkf">
            <PhoneIcon className="h-4 w-4 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-56" data-mp="3qdf4t82yp2b6" />
            651.387.2889
          </a>
          <a href="https://ceniabadillorealtor.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-sans text-sm font-light text-white transition-colors hover:text-gold" data-id="element-57" data-mp="29yxcxcohlklt">
            <GlobeIcon className="h-4 w-4 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-58" data-mp="3gah1hulpfl6d" />
            ceniabadillorealtor.com
          </a>
        </div>

        <div className="mx-auto mt-10 h-px w-24 bg-gold" aria-hidden="true" data-id="element-59" data-mp="3v9b1fhu5q8ey" />

        <p className="mt-6 font-sans text-[11px] font-light uppercase tracking-[0.18em] text-white/60" data-id="element-60" data-mp="3q7ln9tbn1emn">
          Seminario gratuito para la comunidad latina de Minnesota
        </p>
      </div>
    </footer>;
}